// @ts-check

import React from 'react';
import { bool, func, object } from 'prop-types';
import PaperComponent from 'containers/pages/menus/components/PaperComponent';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { PlaceMap } from 'components';
import { CloseOutlinedIcon } from 'components/icons';
import Box from '@mui/material/Box';

/**
 * @component ProfileMap
 * @param {Object} props
 * @param {boolean} props.open
 * @param {Object} props.coordinate
 * @param {string} props.coordinate.lat
 * @param {string} props.coordinate.lng
 * @param {() => void} props.onClose
 * @returns {JSX.Element}
 */
function ProfileMap({ open, coordinate, onClose }) {
	return (
		<Dialog
			open={open}
			onClose={() => onClose()}
			PaperComponent={PaperComponent}
			aria-labelledby="draggable-dialog-title"
		>
			<DialogTitle
				id="draggable-dialog-title"
				style={{
					cursor: 'move',
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}
			>
				<Typography component="span" variant="h5" gutterBottom>
					Address Location
				</Typography>
				<Tooltip title="Close">
					<IconButton onClick={() => onClose()}>
						<CloseOutlinedIcon />
					</IconButton>
				</Tooltip>
			</DialogTitle>
			<DialogContent>
				<Box sx={{ width: '100%', height: '25rem', minWidth: '17.5rem' }}>
					<PlaceMap coordinate={coordinate} />
				</Box>
			</DialogContent>
		</Dialog>
	);
}

ProfileMap.propTypes = { open: bool, coordinate: object, onClose: func };

export default ProfileMap;
